"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PhoneIcon = (props) => {
    return (react_1.default.createElement("svg", { className: props.size, viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("path", { className: props.color, d: "M19.1111 15.1111C18.0045 15.1111 16.9333 14.9333 15.9378 14.6045C15.6311 14.5067 15.28 14.5778 15.0356 14.8223L13.08 16.7822C10.56 15.5022 8.50225 13.4445 7.22225 10.9289L9.17779 8.96446C9.42225 8.72 9.49333 8.36892 9.39558 8.06225C9.06671 7.06671 8.88892 5.99558 8.88892 4.88892C8.88888 4.39554 8.49333 4 8 4H4.88888C4.4 4 4 4.39554 4 4.88888C4 13.2355 10.7645 20 19.1111 20C19.6045 20 20 19.6045 20 19.1111V16C20 15.5067 19.6045 15.1111 19.1111 15.1111Z" })));
};
exports.default = PhoneIcon;
